import { useState } from 'react';
import { Collapse } from 'reactstrap';
import { useAppContext } from '@front-activerse/common-components';

const DayPlanAdvice = ({ advice }) => {
  const {
    svgInline: { DownArrow },
  } = useAppContext();

  const [collapse, setCollapse] = useState(false);

  const description = advice.description
    .trim()
    .split('\n')
    .reduce((carry, line) => {
      if (carry.length) {
        carry.push(<br key={line} />);
      }
      carry.push(line);
      return carry;
    }, []);

  return (
    <div className="advice">
      <h3 onClick={() => setCollapse(!collapse)}>
        {advice.title}
        <span className={collapse ? 'collapse-arrow open' : 'collapse-arrow'}>
          <span className="SVGInline">
            <DownArrow />
          </span>
        </span>
      </h3>
      <Collapse isOpen={collapse}>
        <p>{description}</p>
      </Collapse>
    </div>
  );
};

export default DayPlanAdvice;
